import React from 'react';
import LoginButton from './login.js';
import LogoutButton from './logout.js';
import Profile from './profile.js';

const App = () => {
  return (
    <div className="AppPage">
      <LoginButton />
      <h2>Welcome to the App Page!</h2>
      <p>This is a new component for your React app.</p>
      <LogoutButton />
      <Profile />
    </div>
  );
};

export default App;
